import { Col, Grid, ProgressBar, Row, Table } from 'react-bootstrap'

import ImageZoom from 'react-medium-image-zoom'
import PropTypes from 'prop-types'
import React from 'react'
import { commaSeparatedToNumberArray } from '../../helpers/NumericTransformationsHelper.js'
import { getCrystalImage } from '../../api/ispyb.js'

export default class GridSquarePanel extends React.Component {
  getRow(key, value) {
    return (
      <tr>
        <td xs={5} md={5} className="parameterKey">
          {key}
        </td>
        <td xs={7} md={7} className="parameterValue">
          {value}
        </td>
      </tr>
    )
  }

  render() {
    const _this = this
    let totalNumberOfMovies = 0
    const noFrames = commaSeparatedToNumberArray(this.props.framesCount)[0]
    const dataCollectionIdArray = commaSeparatedToNumberArray(this.props.dataCollectionIdList)
    const startTimeList = this.props.startTimeList.split(',')
    const indexArray = Array.apply(null, { length: dataCollectionIdArray.length }).map(Number.call, Number)
    const statsArray = this.props.stats
    const magnificationArray = commaSeparatedToNumberArray(this.props.magnificationList)
    const progressMotionCorArray = []
    const progressCtfArray = []
    const urlArray = []
    if (statsArray.length === 0) {
      for (let i = 0; i < dataCollectionIdArray.length; i++) {
        statsArray.push({ movieCount: '' })
        progressMotionCorArray.push('')
        progressCtfArray.push('')
        const url = '/sessions/em/proposal/:proposal/datacollection/:dataCollectionId/movies'
          .replace(':token', this.props.token)
          .replace(':proposal', this.props.proposal)
          .replace(':dataCollectionId', dataCollectionIdArray[i])
        urlArray.push(url)
      }
    } else {
      for (let i = 0; i < statsArray.length; i++) {
        totalNumberOfMovies = totalNumberOfMovies + statsArray[i].movieCount
        const progressMotionCor = (statsArray[i].motionCorrectionCount / statsArray[i].movieCount) * 100
        const progressCtf = (statsArray[i].ctfCorrectionCount / statsArray[i].movieCount) * 100
        progressMotionCorArray.push(Math.round(progressMotionCor * 10) / 10)
        progressCtfArray.push(Math.round(progressCtf * 10) / 10)
        const url = '/sessions/em/proposal/:proposal/datacollection/:dataCollectionId/movies'
          .replace(':token', this.props.token)
          .replace(':proposal', this.props.proposal)
          .replace(':dataCollectionId', dataCollectionIdArray[i])
        urlArray.push(url)
      }
    }
    return (
      <div>
        <h3>Sample name : {this.props.sampleName}</h3>
        <Grid fluid style={{ marginTop: '5px' }}>
          <Row>
            <Col xs={12} sm={3} md={3} lg={3}>
              <Table>
                <tbody>
                  {this.getRow('Total number of movies', totalNumberOfMovies)}
                  {this.getRow('Magnification', magnificationArray[0])}
                </tbody>
              </Table>
            </Col>
            <Col xs={12} sm={3} md={3} lg={3}>
              <Table>
                <tbody>
                  {this.getRow('Grid Squares', this.props.gridSquaresCount)}
                  {this.getRow('# Frames', noFrames)}
                </tbody>
              </Table>
            </Col>
            <Col xs={12} sm={3} md={3} lg={3}>
              <Table>
                <tbody>
                  {this.getRow('Voltage', this.props.voltage + ' V')}
                  {this.getRow('Spherical Aberation', '2.7 mm')}
                </tbody>
              </Table>
            </Col>
            <Col xs={12} sm={3} md={3} lg={3}>
              <Table>
                <tbody>
                  {this.getRow('Amplitude Contrast)', '10 %')}
                  {this.getRow('Sampling Rate', this.props.samplingRate + ' Å/pixel')}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Grid>
        <Grid fluid>
          <Row>
            {indexArray.reverse().map(index => (
              <Col xs={12} sm={4} md={4} lg={2} key={index}>
                <Table>
                  <tbody>
                    <tr>
                      <td>
                        <h4>
                          <a href={urlArray[index]} target="_blank" rel="noreferrer">
                            {startTimeList[index]}
                          </a>
                        </h4>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <ImageZoom
                          thumbnail
                          image={{
                            style: { width: '100%' },
                            src: getCrystalImage(
                              _this.props.user,
                              _this.props.proposal,
                              dataCollectionIdArray[index],
                              1
                            ),
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="parameterKey">
                        N<sup>o</sup> movies:
                        <span className="badge" style={{ marginLeft: '10px' }}>
                          {statsArray[index].movieCount}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="parameterKey">
                        <ProgressBar
                          now={progressMotionCorArray[index]}
                          label={`Motion corr: ${progressMotionCorArray[index]}%`}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="parameterKey">
                        <ProgressBar now={progressCtfArray[index]} label={`CTF: ${progressCtfArray[index]}%`} />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            ))}
          </Row>
        </Grid>
      </div>
    )
  }
}

GridSquarePanel.propTypes = {
  token: PropTypes.string,
  proposal: PropTypes.string,
  sessionId: PropTypes.string,
}
